import { Environment } from '@thiememeulenhoff/types';
import { ApiGatewayConfig } from '../types';

export const servicesMockConfig: ApiGatewayConfig = {
  environment: Environment.Test,
};
